import { createContext, useContext } from 'react';

type SidebarContextType = {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (v: boolean) => void;
};

export const SidebarContext = createContext<SidebarContextType | null>(null);

export const SIDEBAR_STORAGE_KEY = 'erpa:sidebar:collapsed';

export function useSidebar() {
  const ctx = useContext(SidebarContext);
  if (!ctx) throw new Error('useSidebar debe usarse dentro de SidebarProvider');
  return ctx;
}
